// ─────────────────────────────────────────────────────────────────────────────
// The account gate, client half (2026-10-17).
//
// Every company created through /signup starts PENDING and waits for BoneFlow
// to approve it — one click by the platform owner — or arrives with an invite
// link that approves it on the spot. The authority is the SERVER:
// functions/accountGate.js refuses the AI tools, email, invites and QuickBooks
// for a company that is not active, and firestore.rules refuses its record
// creates and every client write to the status itself. This file only decides
// which screen a signed-in person sees; it guards nothing.
//
// And the honest limit, kept beside the code that is most tempting to mistake
// for a boundary: the JavaScript bundle is public. Anyone can read every
// screen's code without an account. The gate protects use, cost and data
// entry — not the visibility of the UI.
//
// MISSING MEANS ACTIVE. Companies that predate the gate carry no status and
// are grandfathered as active. Mirror of resolveAccountStatus in
// functions/accountGate.js — keep the two in sync.
// ─────────────────────────────────────────────────────────────────────────────

export const ACCOUNT_STATUS = Object.freeze({
  PENDING: 'pending',
  ACTIVE: 'active',
  DECLINED: 'declined',
});

export function resolveAccountStatus(company) {
  const raw = company ? company.accountStatus : undefined;
  if (raw === undefined || raw === null || raw === ACCOUNT_STATUS.ACTIVE) return ACCOUNT_STATUS.ACTIVE;
  if (raw === ACCOUNT_STATUS.DECLINED) return ACCOUNT_STATUS.DECLINED;
  // 'pending', and anything unrecognised — only a hand edit can produce one,
  // and a typo should leave a company waiting, not let it in.
  return ACCOUNT_STATUS.PENDING;
}

// Did this company come through the gated signup? Only those carry the field.
export function isGatedCompany(company) {
  return !!company && company.accountStatus !== undefined && company.accountStatus !== null;
}

// Must this person confirm their email before the app loads? Only the OWNER of
// a gated company. Grandfathered owners — the platform owner's own accounts
// among them — have never verified, and team members are created by an owner
// who vouches for them. The server applies the identical rule
// (accountGate.assertCompanyActive), so skipping this screen buys nothing.
export function ownerMustVerifyEmail({ company, user, emailVerified }) {
  if (!isGatedCompany(company) || !user) return false;
  return company.ownerUid === user.uid && emailVerified !== true;
}
